<template>
    <BaseTooltip trigger-aria-label="Chat widget toggle tooltip trigger">
        <template #trigger>
            <button
                type="button"
                :aria-label="ariaLabel"
                class="group transition-colors flex items-center gap-2 py-3 md:py-2 px-3 bg-white hover:bg-[#F9F9F9] rounded-3xl border-2 border-[#E8E8E8]"
                @click="handleClick">
                <i class="bi bi-journal-text text-2xl/none text-valence-primary-500" aria-hidden="true"></i>
                <span
                    v-if="visibleWidgetCount > 0"
                    class="inline-flex justify-center items-center bg-[rgba(85,91,162,0.12)] text-valence-primary-500 group-hover:text-[#4B508F] body-bold md:w-8 md:h-8 w-6 h-6 rounded-full">
                    {{ visibleWidgetCount }}
                </span>
            </button>
        </template>
        <template #content>
            {{ isOpen ? "Close Notes" : "Open Notes" }}
        </template>
    </BaseTooltip>
</template>

<script setup lang="ts">
import BaseTooltip from "~vue/components/BaseTooltip.vue";
import { computed } from "vue";

type ChatWidgetListToggleProps = {
    isOpen: boolean;
    visibleWidgetCount?: number;
};

const { isOpen, visibleWidgetCount = 0 } = defineProps<ChatWidgetListToggleProps>();

const emit = defineEmits<{
    click: [];
}>();

function handleClick() {
    emit("click");
}

const ariaLabel = computed(() => {
    return isOpen ? "Close Nadia notes" : `Open Nadia notes: ${visibleWidgetCount} ${visibleWidgetCount === 1 ? "note" : "notes"}`;
});
</script>
